import { render, staticRenderFns } from "./my_booking_manage_details.vue?vue&type=template&id=598450a4&scoped=true&"
import script from "./my_booking_manage_details.vue?vue&type=script&lang=ts&"
export * from "./my_booking_manage_details.vue?vue&type=script&lang=ts&"
import style0 from "./my_booking_manage_details.vue?vue&type=style&index=0&id=598450a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598450a4",
  null
  
)

export default component.exports